var SoundType;
(function (SoundType) {
    SoundType["Music"] = "music";
    SoundType["Win"] = "win";
    SoundType["BetAccepted"] = "betAccepted";
})(SoundType || (SoundType = {}));

export { SoundType };
